<div class="d-flex align-items-center justify-content-between">
  <div class="fw-bold"
       [translate]="'bakerySite.common.customer'">Customer
  </div>
</div>

@if (multiOrder.userName) {
  <div class="font-md mt-2">
    {{ multiOrder.userName }}
  </div>
}

@if (multiOrder.userCompanyName) {
  <div class="font-md">
    {{ multiOrder.userCompanyName }}
  </div>
}

@if (multiOrder.userEmail) {
  <div class="font-md mt-2">
    <a class="text-blue-2 break-all" href="mailto:{{ multiOrder.userEmail }}">{{ multiOrder.userEmail }}</a>
  </div>
}

@if (multiOrder.userPhone) {
  <div class="font-md">
    <a class="text-blue-2" href="tel:{{ multiOrder.userPhone }}">{{ multiOrder.userPhone }}</a>
  </div>
}
